<div mat-dialog-actions align="end">
    <button mat-button (click)="closeClick.emit()" class="tw-text-base">
        Ok
    </button>
</div>
